import _typeof from "@babel/runtime/helpers/typeof";
/**
 * Check if a value is empty.
 */
export function isNotEmpty(value) {
  if (value === null || value === undefined || value === '') {
    return false;
  }
  if (Array.isArray(value) && value.length === 0) {
    return false;
  }
  if (_typeof(value) === 'object' && Object.keys(value).length === 0) {
    return false;
  }
  return true;
}
export function getContext(contextResolver) {
  var checkUseCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
  if (checkUseCase && (typeof (context === null || context === void 0 ? void 0 : context.useCase) !== 'string' || (context === null || context === void 0 ? void 0 : context.useCase.trim().length) === 0)) {
    throw new Error('useCase is required');
  }
  return context;
}